import { render, staticRenderFns } from "./ProfileBoard.vue?vue&type=template&id=c19ec64e&scoped=true"
import script from "./ProfileBoard.vue?vue&type=script&lang=js"
export * from "./ProfileBoard.vue?vue&type=script&lang=js"
import style0 from "./ProfileBoard.vue?vue&type=style&index=0&id=c19ec64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19ec64e",
  null
  
)

export default component.exports